import { decorate, observable } from 'mobx';

import { CurrentUser } from 'tm3-core/api.dtos';

decorate(CurrentUser, {
  id: observable,
  name: observable,
  email: observable,
  clientId: observable,
  userType: observable,
  isAuthenticated: observable,
  isEvaluating: observable,
  settings: observable,
  practitioner: observable,
  location: observable,
  roleId: observable,
  practitionerId: observable,
  tM2UserName: observable,
  roleName: observable,
  userPermissionId: observable,
  tours: observable,
  departments: observable,
  customer: observable,
  userGlobalGuid: observable,
  hasTrialExpired: observable,
  needsVerified: observable,
  bearerToken: observable,
  displayName: observable,
  meta: observable,
  permissions: observable,
  profileUrl: observable,
  referrerUrl: observable,
  refreshToken: observable,
  responseStatus: observable,
  roles: observable,
  sessionId: observable,
  userId: observable,
  userName: observable,
  signatureRxIntegrationCode: observable
});

export default CurrentUser;
